import { InferProps, node } from 'prop-types';
import React, { FC, useState } from 'react';
// import utils from 'core/utils/utils';

import { PageStore, FwPageStoreContext } from './FwPageStoreContext';

const FwPageStoreProvider: FC<Props> = ({ children }) => {
  const [pageStore, setPageStore] = useState<PageStore>({});

  return (
    <FwPageStoreContext.Provider
      value={{
        pageStore,
        setPageStore,
      }}
    >
      {children}
    </FwPageStoreContext.Provider>
  );
};

const propTypes = { children: node };

type Props = InferProps<typeof propTypes>;

FwPageStoreProvider.propTypes = propTypes;

export { FwPageStoreProvider };
